import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';

import { Global, BaoCao } from '../../../shared/global';
import { BsModalComponent, BsModalBodyComponent, BsModalService } from 'ng2-bs3-modal';
import 'jquery'
import 'bootstrap'

//import { Lists_cmmt } from '../../../routes/menu'


const swal = require('sweetalert');
@Component({
  selector: 'app-daotao-donghocedit',
  templateUrl: './donghocedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./donghocedit.component.scss'],
    providers: [ListService, Repository]
})


export class donghoceditComponent implements OnInit {
  doanhnghiepid: string = null;
  public ngaysinh: Date = null;
  public ngaycmnd: Date = null;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputparents: any;
  inputhangbaohiems: any;
  inputphongbans: any;
  inputhangxes: any;
  inputkhachhangs: any;
  inputmausacs: any;
  inputmodels: any;
  inputnhomctmts: any;
  indLoading: boolean = false;
  doituongSelect: any = {
    Id: null, DangKyGoiHocId: null, QuyenSo: null
    , SoPhieu: null, NgayChungTu: null, SoTien: null
    , HinhThuc: null, PhuongThuc: null
    ,Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
    , NguoiId:null, Ngay: null, DonViId: null
  };       
    nhomdtid:string=null;
  hoatdong: string = null;
  inputnhacungcaps: any = [
    { Ten_Doi_Tuong: "Cá nhân", Ma_Doi_Tuong: '0', Id: false },
    { Ten_Doi_Tuong: "Tổ chức", Ma_Doi_Tuong: '1', Id: true },
  ];

  inputhinhthucs: any = [
    { Ten: 'Thanh toán hết', Id: 0 },
    { Ten: 'Đặt cọc', Id: 1 },
    { Ten: 'Thanh toán 1 phần', Id: 2 }
  ];
  inputphuongthucs: any = [
    { Ten: 'Tiền mặt', Id: 0 },
    { Ten: 'Chuyển khoản', Id: 1 },
    { Ten: 'Quẹt thẻ', Id: 2 },
    { Ten: 'Trả góp', Id: 3 },
    { Ten: 'Không có', Id: 4 },
  ];

  inputgioitinhs: any = [
    { Ten_Doi_Tuong: "Nữ", Ma_Doi_Tuong: '0', Id: false },
    { Ten_Doi_Tuong: "Nam", Ma_Doi_Tuong: '1', Id: true },
  ];

  inputloais: any = [
    { text: "Nhân công", value: 0 },
    { text: "Vật tư sơn", value: 1 },
  ];

  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @Output() save: EventEmitter<any> = new EventEmitter();

  @ViewChild('mdChonDoiTuongChung') mdChonDoiTuongChung: BsModalComponent;
  @ViewChild('dtechondoituongchungedit') dtechondoituongchungedit: any;
  
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };
  comboSearchFn2(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }
    constructor( private _dataService: ListService, public repo: Repository) {
       
        
    }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
    ngOnInit(): void {
       
    }

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }

    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
    }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  bnhomctmt: boolean = false;
  currentUser: any;
  tieudectmt: any;
  tieudectmtplace: any;
  hovaten: string = null;
  ///dùng thu tiền chung cho cho học sinh, không phải cho từng bản ghi đăng ký học.
  loadDataInit2(nhomdoituongid: string, id: string, donviid: string, rowdata: any, lopid: string, sotien: any, hovaten: string) {
    this.isSubmitting = false;
    this.hovaten = hovaten;
    this.tieudectmtplace = "Ghi chú";
    this.tieudectmt = "Ghi chú";

    this.hoatdong = "Hoạt động"

    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {

      this.currentUser = JSON.parse(authlogin);
      var giatri = this.currentUser.ds_quyen.filter(name => name.Id === nhomdoituongid.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].Sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].Xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }



    }

    this.nhomdtid = nhomdoituongid;
    setTimeout(() => {
      this.mafocus.nativeElement.focus();
    }, 500);

    console.log(sotien);

    this.doituongSelect = {
      Id: null, DangKyGoiHocId: null, QuyenSo: null
      , SoPhieu: null, NgayChungTu: null, SoTien: sotien
      , HinhThuc: 0, PhuongThuc: 1, NguoiId:null, Ngay: null
      , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
      , DonViId: this.currentUser.id_don_vi
    };
    if (id === null) {

      this.repo.postRequest('api/quanlythuchi/get_maphieu', { DonViId: donviid, LoaiPhieu: 0 })
        .subscribe(response => {
          this.doituongSelect.SoPhieu = response;
        });

      this.doituongSelect.Ngay = new Date();
      this.doituongSelect.NgayChungTu = new Date();
      this.doituongSelect.NguoiId = lopid;
      this.doituongSelect.Created = new Date();
      this.doituongSelect.CreatedBy = this.currentUser.user_name;
      this.doituongSelect.Modified = new Date();
      this.doituongSelect.ModifiedBy = this.currentUser.user_name;
      this.doituongSelect.SoTien = sotien;

      this.repo.postRequest('api/quanlythuchi/get_ngaychungtu', { DonViId: donviid, LoaiPhieu: 0 })
        .subscribe(response => {
          if (response.TuNgay != null)
            this.doituongSelect.NgayChungTu = new Date(response.TuNgay);
        });


    }
    else {
      console.log("t11");
      this.repo.postRequest("api/dangkygoihoc/getbyid_donghoc/", { IdGuid: id, NhomDoiTuongId: nhomdoituongid, UserName: this.currentUser.user_name })
        .subscribe(response => {
          console.log(response);
          this.doituongSelect.Id = id;
          this.doituongSelect.NguoiId = lopid;
          this.doituongSelect.QuyenSo = response.QuyenSo;
          this.doituongSelect.SoPhieu = response.SoPhieu;
          this.doituongSelect.SoTien = response.SoTien;
          this.doituongSelect.HinhThuc = response.HinhThuc;
          this.doituongSelect.PhuongThuc = response.PhuongThuc;
          this.doituongSelect.GhiChu = response.GhiChu;

          if (response.DonViId != null)
            this.doituongSelect.DonViId = response.DonViId;

          if (response.Created != null)
            this.doituongSelect.Created = new Date(response.Created);
          this.doituongSelect.CreatedBy = response.CreatedBy;
          this.doituongSelect.Modified = new Date();
          this.doituongSelect.ModifiedBy = this.currentUser.user_name;
          if (response.NgayChungTu != null)
            this.doituongSelect.NgayChungTu = new Date(response.NgayChungTu);
          else
            this.doituongSelect.NgayChungTu = null;

          if (response.Ngay != null)
            this.doituongSelect.Ngay = new Date(response.Ngay);
          else
            this.doituongSelect.Ngay = null;



        });
    }


  }
  //dùng cho thu tiền đăng ký chung và riêng cho từng bản ghi.
  //rowdata: nhansuId
  //lopid: dangkyhocId
  loadDataInit(nhomdoituongid: string, id: string, donviid: string, rowdata : any, lopid: string,sotien:any, hovaten: string) {
    this.isSubmitting = false;
    this.hovaten = hovaten;
    this.tieudectmtplace = "Ghi chú";
    this.tieudectmt = "Ghi chú";

      this.hoatdong = "Hoạt động"

          var authlogin = localStorage.getItem('currentUser');
          if (authlogin) {

            this.currentUser = JSON.parse(authlogin);
            var giatri = this.currentUser.ds_quyen.filter(name => name.Id === nhomdoituongid.toLowerCase());
            if (giatri != null && giatri.length > 0) {
              if (giatri[0].Them == true)
                this.quyen_them = true;
              else
                this.quyen_them = false;
              if (giatri[0].Sua == true)
                this.quyen_sua = true;
              else
                this.quyen_sua = false;
              if (giatri[0].Xoa == true)
                this.quyen_xoa = true;
              else
                this.quyen_xoa = false;
            }

            

          }    

        this.nhomdtid = nhomdoituongid;
        setTimeout(() => {
            this.mafocus.nativeElement.focus();  
    }, 500);

    console.log(sotien);
    
    this.doituongSelect = {
      Id: null, DangKyGoiHocId: null, QuyenSo: null
      , SoPhieu: null, NgayChungTu: null, SoTien: sotien
      , HinhThuc: 0, PhuongThuc: 1, Ngay: null, DonViId: this.currentUser.id_don_vi
      , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
    };    
    if (id === null)
    {     

      this.repo.postRequest('api/quanlythuchi/get_maphieu', { DonViId: donviid, LoaiPhieu: 0 })
        .subscribe(response => {
          this.doituongSelect.SoPhieu = response;
        });

      

      this.doituongSelect.Ngay = new Date();
      this.doituongSelect.NgayChungTu = new Date();
      this.doituongSelect.DangKyGoiHocId = lopid;
          this.doituongSelect.Created = new Date();
          this.doituongSelect.CreatedBy = this.currentUser.user_name;
          this.doituongSelect.Modified = new Date();
      this.doituongSelect.ModifiedBy = this.currentUser.user_name;
      this.doituongSelect.SoTien = sotien;

      this.repo.postRequest('api/quanlythuchi/get_ngaychungtu', { DonViId: donviid, LoaiPhieu: 0 })
        .subscribe(response => {
          if (response.TuNgay != null)
            this.doituongSelect.NgayChungTu = new Date(response.TuNgay);
        });
         
          
    }
        else {
      console.log("t11");
      this.repo.postRequest("api/dangkygoihoc/getbyid_donghoc/", { IdGuid: id, NhomDoiTuongId: nhomdoituongid, UserName: this.currentUser.user_name })
            .subscribe(response => {  
                console.log(response);
              this.doituongSelect.Id = id;
              this.doituongSelect.DangKyGoiHocId = lopid;
              this.doituongSelect.QuyenSo = response.QuyenSo;
              this.doituongSelect.SoPhieu = response.SoPhieu;
              this.doituongSelect.SoTien = response.SoTien;
              this.doituongSelect.HinhThuc = response.HinhThuc;
              this.doituongSelect.PhuongThuc = response.PhuongThuc;
              this.doituongSelect.GhiChu = response.GhiChu;

              if (response.DonViId != null)
                this.doituongSelect.DonViId = response.DonViId;
              
              if (response.Created != null)
                this.doituongSelect.Created = new Date(response.Created);
              this.doituongSelect.CreatedBy = response.CreatedBy;
              this.doituongSelect.Modified = new Date();
              this.doituongSelect.ModifiedBy = this.currentUser.user_name;
              if (response.NgayChungTu != null)
                this.doituongSelect.NgayChungTu = new Date(response.NgayChungTu);
              else
                this.doituongSelect.NgayChungTu = null;
              
              if (response.Ngay != null)
                this.doituongSelect.Ngay = new Date(response.Ngay);
              else
                this.doituongSelect.Ngay = null;
           
            }); 
        }
        
       
    }
   
    keyTenPress(event: any) { 
        if (event.which === 13) {
            this.slCapTren.focus();
            event.preventDefault();
          }
   }
    public closeModal(){
        this.save.emit(null);
  }
  // Add this property to the class:
  isSubmitting: boolean = false;
  // Update the saveproduct method:
  public saveproduct() {
    // Set submitting flag to true
    this.isSubmitting = true;

    if (this.doituongSelect.SoPhieu == null || this.doituongSelect.SoPhieu == "") {
      swal('Lỗi!', 'Vui lòng nhập số phiếu!.', 'error');
      this.isSubmitting = false; // Reset flag on error
      return;
    }
    if (this.doituongSelect.NgayChungTu == null) {
      swal('Lỗi!', 'Vui lòng nhập ngày nộp!.', 'error');
      this.isSubmitting = false; // Reset flag on error
      return;
    }
    if (this.doituongSelect.SoTien == null) {
      swal('Lỗi!', 'Vui lòng nhập số tiền!.', 'error');
      this.isSubmitting = false; // Reset flag on error
      return;
    }
    if (this.doituongSelect.HinhThuc == null) {
      swal('Lỗi!', 'Vui lòng nhập hình thức!.', 'error');
      this.isSubmitting = false; // Reset flag on error
      return;
    }
    if (this.doituongSelect.PhuongThuc == null) {
      swal('Lỗi!', 'Vui lòng nhập phương thức!.', 'error');
      this.isSubmitting = false; // Reset flag on error
      return;
    }

    console.log(this.doituongSelect);

    $('#loading').show();
    this.repo.postRequest("api/dangkygoihoc/addorupdate_donghoc", this.doituongSelect)
      .subscribe(
        response => {
          $('#loading').hide();
          this.isSubmitting = true; // Reset flag after response
          if (response.success == true) {
            this.doituongSelect.Id = response.data;
            this.save.emit(this.doituongSelect);
          }
          else {
            swal('Lỗi!', response.message, 'error');
          }
        },
        error => {
          $('#loading').hide();
          this.isSubmitting = false; // Reset flag on error
          swal('Lỗi!', 'Có lỗi xảy ra khi lưu dữ liệu', 'error');
        }
      );
  }
   
  mBackdrop: any;
  haveBackdrop() {
    if ($('.modal-backdrop').length > 0) {
      $('.modal-backdrop').css("z-index", -1)
      clearTimeout(this.mBackdrop);
      return true;
    }

    return false;
  }
  indexdt: number;
  cotdt: string;


  public export(kieuin) {
    if (this.doituongSelect.Id == null)
      swal('Cảnh báo!', 'Lưu thông tin đóng học trước khi in!.', 'error');

    $('#loading').show();
    let data = {
      Id: "4A1EF676-B194-41E4-8506-D608EF9F8F24",
      Type: kieuin,
      Data: JSON.stringify({ Id: this.doituongSelect.Id, UserName: this.currentUser.user_name, DonViId: this.currentUser.id_don_vi})
    };
    if (kieuin === 'xlsx') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          if (response == "L") {
            this.repo.postRequest(Global.BASE_BaoCao_SAVE, data).subscribe(
              data => {
                $('#loading').hide();
              },
              error => {

              }
            );
          }
          else {
            $('#loading').hide();
            var file = new Blob([response.body], { type: 'vnd.ms-excel' });
            var fileURL = URL.createObjectURL(file);
            var a = document.createElement("a");
            a.href = fileURL;
            let ngay = new Date();
            a.download = "hoa_don.xlsx";
            document.body.appendChild(a);
            a.click();
          }


        });
    }
    if (kieuin === 'pdf') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          //console.log("tt");
          //console.log(response);
          if (response == "L") {
            this.repo.postRequest(Global.BASE_BaoCao_SAVE, data).subscribe(
              data => {
                $('#loading').hide();
              },
              error => {

              }
            );
          }
          else {
            $('#loading').hide();
            var file = new Blob([response.body], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, "EPrescription");
            var a = document.createElement("a");
            a.href = fileURL;
            let ngay = new Date();
            a.download = this.hovaten + ".pdf";
            document.body.appendChild(a);
            a.click();

          }

        });
    }



  }
  public export2(kieuin) {
    if (this.doituongSelect.Id == null)
      swal('Cảnh báo!', 'Chưa chọn thông tin đóng học để in hóa đơn!.', 'error');
    let filename = "";

    //filename = this.selectedRow2.HoVaTen + " " + this.selectedRow2.MaLop;

    $('#loading').show();
    let data = {
      Id: "D7097D40-37F5-4300-AB66-C057613F831C",
      Type: kieuin,
      Data: JSON.stringify({ Id: this.doituongSelect.Id, UserName: this.currentUser.user_name, DonViId: this.currentUser.id_don_vi })
    };
    if (kieuin === 'xlsx') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          if (response == "L") {
            this.repo.postRequest(Global.BASE_BaoCao_SAVE, data).subscribe(
              data => {
                $('#loading').hide();
              },
              error => {

              }
            );
          }
          else {
            $('#loading').hide();
            var file = new Blob([response.body], { type: 'vnd.ms-excel' });
            var fileURL = URL.createObjectURL(file);
            var a = document.createElement("a");
            a.href = fileURL;
            let ngay = new Date();
            a.download = "hoa_don.xlsx";
            document.body.appendChild(a);
            a.click();
          }


        });
    }
    if (kieuin === 'pdf') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          //console.log("tt");
          //console.log(response);
          if (response == "L") {
            this.repo.postRequest(Global.BASE_BaoCao_SAVE, data).subscribe(
              data => {
                $('#loading').hide();
              },
              error => {

              }
            );
          }
          else {
            $('#loading').hide();
            var file = new Blob([response.body], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, "EPrescription");

            //var a = document.createElement("a");
            //a.href = fileURL;
            //let ngay = new Date();
            //a.download = this.hovaten + ".pdf";
            //document.body.appendChild(a);
            //a.click();

            //var a = document.createElement("a");
            //a.href = fileURL;
            //let ngay = new Date();
            //a.download = filename + ".pdf";
            //document.body.appendChild(a);
            //a.click();
          }

        });
    }



  }

}
